<template>
    <div id="cxMgmtBox">        
        <div class="searchWrap">
            <div class="row">
                <div class="itemWrap">
                    <span >資料來源</span>
                    <el-select v-model="listQuery.source" placeholder="請選擇資料來源" clearable style="width: 200px;margin-left: 10px;">
                        <!-- <el-option label="總行派案" value="總行派案"></el-option>
                        <el-option label="續約重訂" value="續約重訂"></el-option>                    -->    
                        <el-option label="自行開發" value="自行開發"></el-option>                         
                    </el-select>                
                    <span style="margin-left:15px;" >專案名稱</span>
                    <el-select v-model="listQuery.ProjectName" placeholder="請選擇專案名稱" clearable style="width: 200px;">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option v-for="item in ProjectNameList" :key="item.ID" :label="item.ProjectName" :value="item.ProjectName"></el-option>                        
                    </el-select>                    
                </div>                
                <div class="itemWrap" style="margin-left: 10px;">
                    <el-input v-model="keyword" placeholder="公司名稱 / 統一編號 " style="width:60%;margin:auto 15px;" clearable></el-input>                                        
                    <el-button style="margin-left: 20px;" type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>
                </div>                
            </div>
            <div class="row2">
                <div>
                    <span >建立時間</span>
                    <el-date-picker
                        v-model="dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="開始日期"
                        end-placeholder="結束日期"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
                <div class="buttonOptBox">        
                    <el-button type="success" @click="openAddTagDialog"><font-awesome-icon icon="plus"  style="margin-right:5px;" />新增企業標籤</el-button>            
                    <el-button type="danger" @click="addNewCx"><font-awesome-icon icon="plus"  style="margin-right:5px;" />新增潛在客戶</el-button>                                
                    <el-button v-if="btnUploadNameVisible" type="success" @click="uploadNameList"><font-awesome-icon icon="plus"  style="margin-right:5px;" />上傳名單</el-button>
                    <el-button v-if="btnStartCaseVisible" type="success" @click="startupBatchCase"><font-awesome-icon icon="edit"  style="margin-right:5px;" />整批起案</el-button>
                    <el-button type="danger" @click="exportCase"><font-awesome-icon icon="folder-open"  style="margin-right:5px;" />匯出</el-button>                    
                </div>                
            </div>
        </div>
        <div class="content" >
            <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableData" @selection-change="handleSelectionChange">                            
                <el-table-column type="selection" width="50" ></el-table-column>
                <el-table-column label="統一編號"  prop="UniComNm" min-width="15%">
                    <template slot-scope="scope">        
                        <el-tooltip content="將開啟新頁" placement="top">
                        <a class="goDetailPage" @click="doShowCompanyDetail(scope.row)">{{ scope.row.UniComNm }}</a>
                        </el-tooltip>                          
                    </template>    
                </el-table-column>                              
                <el-table-column label="公司名稱" prop="ComName"  min-width="15%">     
                    <template slot-scope="scope">                       
                        <el-tooltip content="將開啟新頁" placement="top">
                        <a class="goDetailPage" @click="doshowDetail(scope.row)">{{ scope.row.ComName }}</a>
                        </el-tooltip>                          
                    </template>
                </el-table-column>              
                           
                <el-table-column label="專案名稱"  prop="ProjectName" min-width="15%"  >
                </el-table-column>                        
                <el-table-column label="建立時間"  prop="CreateDt" min-width="15%"  >
                </el-table-column>                        
                <el-table-column label="企業資訊"  min-width="25%"   >
                    <template slot-scope="scope">   
                        <!-- <el-button type="text" @click="btnOpNews(scope.row)">關聯新聞</el-button> -->
                        <el-button type="text" @click="btnOpDetail(scope.row)">明細</el-button>
                        <el-button type="text" @click="btnOpDelete(scope.row)">刪除</el-button>
                        <el-button v-if="btnStartCaseVisible" type="text" @click="btnOpStartCase(scope.row)">起案</el-button>
                    </template>
                </el-table-column>                                                                                     
            </el-table>                
        </div>
        <div class="pageBox">
            <Pagination
                @currentChange="pageChange"
                :pageSize="this.listQuery.Page_Size"
                :propsCurrentPage="this.listQuery.Page_Num"
                :totalLists="totalLists">
            </Pagination>
        </div>  


        <el-dialog :title="popTitle" :visible.sync="dialogVisible" width="50%" center>
            <div class="dialogBox" >
                <div class="cxInfoitem"><label >統一編號</label><el-input v-model="selectedCase.UniComNm" ></el-input></div>
                <div class="cxInfoitem"><label >公司名稱</label><el-input v-model="selectedCase.ComName" ></el-input></div>
                <div class="cxInfoitem"><label >資料來源</label><el-input v-model="selectedCase.Source" disabled  ></el-input>                    </div>
                <div class="cxInfoitem"><label >專案名稱</label>
                    <el-select v-model="changeProjectID" placeholder="請選擇專案名稱"  style="width: 200px;">
                        <el-option v-for="item in ProjectNameList" :key="item.ID" :label="item.ProjectName" :value="item.ID"></el-option>                        
                    </el-select>
                    <el-dropdown trigger="click" style="margin-left: 20px;" @command="handleProjectName">
                        <el-button type="primary">
                            <font-awesome-icon icon="cog" style="margin: auto 10px;" />操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="add">
                                <font-awesome-icon icon="plus" style="margin-right:8px;" />新增專案名稱
                            </el-dropdown-item>
                            <el-dropdown-item command="edit">
                                <font-awesome-icon icon="edit" style="margin-right:8px;" />修改專案名稱
                            </el-dropdown-item>
                            <el-dropdown-item command="delete">
                                <font-awesome-icon icon="trash" style="margin-right:8px;" />刪除專案名稱
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>                             
                </div>
                <div class="cxInfoitem"><label >區處</label><el-input v-model="selectedCase.DivisionName" disabled></el-input></div>   
                <div class="cxInfoitem"><label >分行名稱</label><el-input v-model="selectedCase.DeptName" disabled></el-input></div>
                <div class="cxInfoitem"><label >承辦人</label><el-input v-model="selectedCase.UserName" disabled></el-input></div>
                <div class="cxInfoitem"><label >建立時間</label><el-input v-model="selectedCase.CreateDt" disabled></el-input></div>
                <div class="cxInfoitem"><label >備註</label><el-input v-model="selectedCase.Memo" :maxlength="100" show-word-limit></el-input></div>
            </div>
          <span slot="footer" class="dialog-footer">
                <el-button type="primary"  @click="saveDetail()" ><font-awesome-icon icon="edit"  style="margin-right:5px;" />儲存</el-button>
                <el-button type="danger"  @click="closeDialog()" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
          </span>
        </el-dialog>        
        
        <el-dialog title="案件起案" :visible.sync="startCaseDialogVisible" width="80%" center>
            <div class="dialogBox" >
                <el-form :model="selectedCase" label-width="120px" label-position="left">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="統一編號">
                                <span>{{ selectedCase.UniComNm }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="公司名稱">
                                <span>{{ selectedCase.ComName }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="專案名稱">
                                <span>{{ selectedCase.ProjectName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="區處">
                                <span>{{ selectedCase.DivisionName }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="分行名稱">
                                <span>{{ selectedCase.DeptName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="承辦人">
                                <span>{{ selectedCase.UserName }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="預計訪問時間">
                                <el-date-picker v-model="expectedVisitDate" type="date" value-format="yyyy-MM-dd" placeholder="選擇日期" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="限辦期限">
                                <el-date-picker v-model="dueDate" type="date" value-format="yyyy-MM-dd" placeholder="選擇日期" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="備註">
                                <el-input v-model="selectedCase.Memo" type="textarea" :rows="3" :maxlength="200" show-word-limit placeholder="請輸入備註"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click="startCase()" ><font-awesome-icon icon="edit"  style="margin-right:5px;" />起案</el-button>
                    <el-button type="danger"  @click="startCaseDialogVisible = false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog>

        <el-dialog title="上傳名單" :visible.sync="showupNameList" width="50%" center>
            <div class="dialogBox" >
                <div class="row1">
                    <div class="itemBox">
                        <label>上傳檔案：</label>
                        <!-- 修改這裡，改用普通的文件輸入元素 -->
                        <input
                          type="file"
                          @change="handleFileChange"
                                                    accept=".xlsx"
                          ref="fileInput"
                          style="display:none"
                        />
                        <el-button size="small" type="primary" icon="el-icon-upload" @click="triggerFileInput">
                          選擇檔案
                        </el-button>
                        <span v-if="selectedFile" style="margin-left: 10px;">
                          已選擇: {{ selectedFile.name }}
                        </span>
                        <a href="/tbbhq.xlsx" download="tbbhq.xlsx" style="margin-top:5px;margin-left: 10px;">下載範例檔案</a>
                    </div>
                </div>
                <!-- 格式提示保持不變 -->
                <div class="row1" style="margin: -10px 0px 15px 90px;font-size: smaller;color:green">
                    格式: 項次、區處名稱(*)、分行代號(*)、統一編號(*) 、客戶名稱、專案名稱(*)、限辦期限、信評等級、 資本額 、員工人數、台幣放款戶(Y/N)、有外幣存款(Y/N)、衍生性金融商品(Y/N)、近一年貢獻度(千元)、外匯存款AUM(千元)、AUM、備註1、備註2、備註3
                </div>

                <!-- 預覽數據 -->
                <div v-if="parsedData.length > 0">
                    <h4>檔案預覽 (前 3 筆資料):</h4>
                    <el-table :data="parsedData.slice(0, 3)" border :header-cell-style="{ fontSize: '10px' }" style="width: 100%;">
                      <el-table-column prop="項次" label="項次"></el-table-column>
                      <el-table-column prop="區處名稱(*)" label="區處名稱"></el-table-column>
                      <el-table-column prop="分行代號(*)" label="分行代號"></el-table-column>
                      <el-table-column prop="統一編號(*)" label="統一編號"></el-table-column>
                      <el-table-column prop="客戶名稱" label="客戶名稱"></el-table-column>
                      <el-table-column prop="專案名稱(*)" label="專案名稱"></el-table-column>
                      <el-table-column prop="限辦期限" label="限辦期限"></el-table-column>
                      <el-table-column prop="信評等級" label="信評等級"></el-table-column>
                      <el-table-column prop="資本額" label="資本額"></el-table-column>
                      <el-table-column prop="員工人數" label="員工人數"></el-table-column>
                      <el-table-column prop="台幣放款戶(Y/N)" label="台幣放款戶(Y/N)"></el-table-column>
                      <el-table-column prop="有外幣存款(Y/N)" label="有外幣存款(Y/N)"></el-table-column>
                      <el-table-column prop="衍生性金融商品(Y/N)" label="衍生性金融商品(Y/N)"></el-table-column>
                      <el-table-column prop="近一年貢獻度(千元)" label="近一年貢獻度(千元)"></el-table-column>
                      <el-table-column prop="外匯存款AUM(千元)" label="外匯存款AUM(千元)"></el-table-column>
                      <el-table-column prop="AUM" label="AUM"></el-table-column>
                      <el-table-column prop="備註1" label="備註1"></el-table-column>
                      <el-table-column prop="備註2" label="備註2"></el-table-column>
                      <el-table-column prop="備註3" label="備註3"></el-table-column>
                    </el-table>
                    <div style="margin-top: 10px; color: #606266; font-size: 14px;">
                      共 {{ parsedData.length }} 筆資料
                    </div>
                </div>

                <!-- 備註保持不變 -->
                <!-- <div style="margin: 5px 5px;">
                    <label>備註：</label>
                    <el-input type="textarea" rows="2" v-model="addInfo.memo" placeholder="簡明描述備註" style="width:100%;margin-right:15px;margin-top:15px" clearable></el-input>                    
                </div>                 -->
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click="submitData" :disabled="parsedData.length === 0" :loading="submitting" icon="el-icon-plus" > 送出資料</el-button>
                    <el-button type="danger" @click="cancelUpload" icon="el-icon-close">重置</el-button>
                    <el-button type="light" @click="showupNameList=false" icon="el-icon-close">關閉</el-button>
            </span>
        </el-dialog> 

        <!-- 資料檢核錯誤列表 -->
        <el-dialog title="資料檢核錯誤" :visible.sync="errorDialogVisible" width="50%" center>
            <div style="max-height: 400px; overflow-y: auto;">
                <div style="margin-bottom: 10px; color: #E6A23C; font-weight: bold;">
                    共發現 {{ validationErrors.length }} 個錯誤：
                </div>
                <el-table :data="validationErrors" border stripe style="width: 100%;">
                    <el-table-column type="index" label="#" width="50"></el-table-column>
                    <el-table-column prop="error" label="錯誤訊息"></el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="errorDialogVisible = false">確定</el-button>
            </span>
        </el-dialog>
        
        <!-- 新增企業標籤對話框 -->
        <el-dialog title="新增企業標籤" :visible.sync="showAddTagDialog" width="30%" center>
            <div class="tag-form">
                <!-- 公司名稱顯示 -->
                <div class="form-item">
                    <label>公司名稱</label>
                    <div style="padding: 8px; background-color: #f5f7fa; border-radius: 4px; border: 1px solid #dcdfe6;">
                        <div v-if="selectedComUniComNmList.length === 0" style="color: #909399;">
                            尚未選擇公司
                        </div>
                        <div v-else style="color: #303133;">
                            <span v-if="selectedComUniComNmList.length === 1">
                                {{ getCompanyName(selectedComUniComNmList[0]) }}
                            </span>
                            <span v-else>
                                {{ getCompanyName(selectedComUniComNmList[0]) }} 等 {{ selectedComUniComNmList.length }} 家公司
                            </span>
                        </div>
                    </div>
                </div>
                <!-- 標籤輸入框 -->
                <div class="form-item">
                    <label>標籤內容(可輸入多個標籤用逗號, 隔開)</label>
                    <el-input v-model="newTagForm.content" placeholder="請輸入標籤內容"></el-input>
                </div>
            </div>
            
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveNewTagFromDrawer" :disabled="selectedComUniComNmList.length === 0">儲存</el-button>
                <el-button @click="showAddTagDialog = false">取消</el-button>        
            </span>
        </el-dialog>
        
            
    </div>
</template>


<script>
import Pagination from '../../components/Pagination.vue';
import { Dialog } from 'element-ui';
import { notify, handleError } from '../../utils/notify';
import ExcelJS from 'exceljs';
import { set } from 'nprogress';
export default {
    components: {Pagination},
    data() {
        return {

            btnUploadNameVisible: false, // 控制上傳名單按鈕顯示
            btnStartCaseVisible: false, // 控制起案按鈕顯示

            uploadFileName: '',
            
            // 新增企業標籤相關
            showAddTagDialog: false,
            selectedComUniComNm: '', // 用 UniComNm 作為唯一識別符
            selectedComUniComNmList: [], // 多個選中的公司列表
            newTagForm: {
                content: ''
            },

            popTitle: "新增潛在客戶",
            showupNameList: false,
            selectedFile: null,
            parsedData: [],
            submitting: false,
            addInfo: {
                memo: ''
            },
            errorDialogVisible: false,
            validationErrors: [],

            keyword: "",
            dialogVisible: false,
            startCaseDialogVisible: false,
            tableData: [],            

            selectedItems: [],
            ProjectNameList: [],

            changeProjectID: "",

            dateRange: [],

            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },





            totalLists:0,
            keyword: "",  

            listQuery: {
                Page_Size:10,
                Page_Num:1
            },   
            details: {},
            selectedCase: {},
            expectedVisitDate: '',
            dueDate: '',
            addOrEdit: 'add',
            
            // 用於跨頁勾選
            selectedCases: [],
            selectedCaseMap: {},
            isRestoringSelection: false

        }        

        
    },
    methods: {

        // 處理專案名稱的新增、修改、刪除
        handleProjectName(command) {
            if (command === 'add') {
                // 處理新增專案名稱邏輯
                this.addProjectName();                
            } else if (command === 'edit') {
                // 處理修改專案名稱邏輯
                this.editProjectName();
            } else if (command === 'delete') {
                // 處理刪除專案名稱邏輯
                this.deleteProjectName();
            }
        },
        
        // 新增專案名稱
        async addProjectName() {
            // 彩出輸入對話框
            this.$prompt('請輸入新的專案名稱', '新增專案名稱', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                inputPattern: /.+/,
                inputErrorMessage: '專案名稱不可為空',
                customClass: 'custom-prompt-dialog'
            }).then(async ({ value }) => {
                if( value.trim() === '' ) {
                    notify({
                        title: "警告",
                        message: "專案名稱不可為空",
                        type: "warning",
                    });
                    return;
                }
                // 使用者輸入的專案名稱                
                const qry = {
                    "ProjectName": value.trim()
                };

                // 判斷value是否已存在於ProjectNameList
                const exists = this.ProjectNameList.some(item => item.ProjectName === value.trim());
                if (exists) {
                    notify({
                        title: "警告",
                        message: `專案名稱 "${value.trim()}" 已存在`,
                        type: "warning",
                    });
                    return;
                }
                
                try {
                    const res = await this.$api.apipocxpj.pocxpj_create(qry);
                    console.log('新增專案名稱成功:', res);
                    // 重新載入專案名稱列表
                    await this.loadProjectNameList(); 
                    this.selectedProjectName = res.data.ID; // 選擇剛新增的專案名稱
                    notify({
                        title: "成功",
                        message: `成功新增專案名稱 "${value.trim()}"`,
                        type: "success",
                    });

                } catch (err) {
                    handleError(err, '新增專案名稱失敗');
                }
            }).catch(() => {
                // 使用者取消輸入
            });


        },
        // 修改專案名稱
        editProjectName() {
            // 請檢查是否有選擇專案名稱
            if (!this.changeProjectID) {
                notify({
                    title: "警告",
                    message: "請先選擇要修改的專案名稱",
                    type: "warning",
                });
                return;
            }

            this.$prompt('請輸入新的專案名稱', '修改專案名稱', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                inputValue: "",
                inputPattern: /.+/,
                inputErrorMessage: '專案名稱不可為空',
                customClass: 'custom-prompt-dialog'
            }).then(async ({ value }) => {
                // 使用者輸入的新的專案名稱
                const qry = {
                    "ID": this.changeProjectID,
                    "ProjectName": value.trim()
                };
                
                try {
                    const res = await this.$api.apipocxpj.pocxpj_update(qry);
                    console.log('修改專案名稱成功:', res);

                    if( res.statuscode == 200 ) {
                        await this.loadProjectNameList();
                        notify({
                            title: "成功",
                            message: `成功修改專案名稱為 "${value.trim()}"`,
                            type: "success",
                        });
                    }
                    else {
                        notify({
                            title: "錯誤",
                            message: `修改專案名稱失敗: ${res.message || '未知錯誤'}`,
                            type: "error",
                        });
                    }
                } catch (err) {
                    handleError(err, '修改專案名稱失敗');
                }
            }).catch(() => {
                // 使用者取消輸入
            });

        },
        // 刪除專案名稱
        deleteProjectName() {

            // 請檢查是否有選擇專案名稱
            if (!this.changeProjectID) {
                notify({
                    title: "警告",
                    message: "請先選擇要修改的專案名稱",
                    type: "warning",
                });
                return;
            }      
            // 由this.selectProjectName, 找出專案名稱
            const proj = this.ProjectNameList.find(item => item.ID == parseInt(this.changeProjectID));
            
            console.log('準備刪除專案名稱:', proj);
            // 彩出確認對話框
            this.$confirm(`確定要刪除專案名稱 "${proj.ProjectName}" 及其所有潛在客戶 嗎?`, '刪除確認', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'custom-confirm-dialog'
            }).then(async () => {
                // 再將此專案中的所有潛在客戶都刪除
                // 先找出此專案名稱下的所有潛在客戶
                const qry = {
                    "ProjectName": proj.ProjectName,
                    "Page_Num": 1,
                    "Page_Size": 100
                };
                const respPocx = await this.$api.apipocx.pocx_search(qry);
                if( respPocx.data.length > 0 ) {
                    const idsToDelete = respPocx.data.map(item => item.ID);
                    console.log('刪除此專案下的潛在客戶IDs:', idsToDelete);
                    // 呼叫刪除API
                    const respDeletePocx = await this.$api.apipocx.pocx_delete( { IDs: idsToDelete } );
                    console.log('刪除潛在客戶結果:', respDeletePocx);
                }

                // 使用者確認刪除的處理邏輯
                console.log('刪除專案名稱:', proj.ProjectName);


                const res = await this.$api.apipocxpj.pocxpj_delete({ ID: this.changeProjectID });

                console.log('刪除專案名稱成功:', res);

                

                
                // 從陣列中刪除所選項目
                const index = this.ProjectNameList.findIndex(item => item.ID == parseInt(this.changeProjectID));
                if (index !== -1) {
                    this.ProjectNameList.splice(index, 1);
                }
                
                // 這裡可以加入從後端刪除專案名稱的程式碼
                notify({
                    type: 'success',
                    message: '專案名稱已成功刪除'
                });
                
                // 重置選擇
                this.changeProjectID = '';
            }).catch(() => {
                // 使用者取消刪除
                notify({
                    type: 'info',
                    message: '已取消刪除操作'
                });
            });
        },        

        // 將可能為 Date 或字串的日期轉換成 YYYY-MM-DD 字串
        formatToDateString(value) {
            if (!value) return '';
            let d = value;
            if (!(value instanceof Date)) {
                d = new Date(value);
            }
            if (isNaN(d.getTime())) return '';
            return d.toISOString().split('T')[0];
        },
        async getDivisionInfo(DeptID) {
            // 呼叫API取得區處與分行名稱
            const qry = {
                "DeptID": DeptID,
                "Page_Num": 1,
                "Page_Size": 1
            }
            try {
                const response = await this.$api.apidivison.division_info_list(qry);                
                return response.data[0];
            } catch (error) {
                console.error("獲取區處分行資訊失敗", error);
                notify({ title: '錯誤', message: '獲取區處分行資訊失敗，請稍後再試', type: 'error' });                
                return null;
            }
        },

        async addNewCx() {
            this.selectedCase = {
                UniComNm: '',
                ComName: '',
                Source: '自行開發',
                ProjectName: '',
                DivisionName: '',
                DeptName: '',
                UserName: '',
                CreateDt: '',
                Memo: ''
            };
            this.popTitle = "新增潛在客戶";
            // 找出使用者所屬的區處與分行, 預設帶入
            const deptID = window.localStorage.getItem("deptID");
            const divisionInfo = await this.getDivisionInfo(deptID);

            const un = this.$store.state.un || this.$store.state.userInfo?.UserName || '';
            console.log("使用者帳號:", un);
            console.log("完整使用者資訊:", this.$store.state.userInfo);

            if (divisionInfo) {
                this.selectedCase.DivisionName = divisionInfo.DivisionName;
                this.selectedCase.DeptName = divisionInfo.DeptName;
            }
            this.selectedCase.UserName = this.$store.state.userInfo.UserName;
            this.selectedCase.CreateDt = new Date().toISOString().split('T')[0]; // 預設為今天日期

            this.addOrEdit = 'add';
            this.changeProjectID = '';
            this.dialogVisible = true;
        },

        doshowDetail(row) {
            console.log(row);
            // 開新頁面, 轉到ctmMapCx.vue頁面
            this.$queryRecord(this, row.ComName, 'company');  // 記錄點擊公司名
            const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
            window.open(url, '_blank');

        },    
        
        loadProjectNameList() {
            
            const qry = {
                "Page_Num": 1,
                "Page_Size": 20,
                "DeptID": window.localStorage.getItem("deptID")          
            }        
            console.log("載入專案名稱參數",qry);    
            this.$api.apipocxpj.pocxpj_search(qry).then(response => {
                console.log("專案名稱列表",response);
                this.ProjectNameList = response.data;
            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "獲取專案名稱失敗，請稍後再試",
                    type: "error"
                });                
            });
        },      

        // 串到公司詳細資訊頁... http://localhost:1200/companyDetail?comid=90699843&comname=台泥東立綠能股份有限公司
        async doShowCompanyDetail(data) {
            console.log(data);
            const comid = data.UniComNm;
            const comname = data.ComName;

            this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名
            // 開啟新視窗, 顯示公司詳細資訊
            const url = `/companyDetail?comid=${comid}&comname=${comname}`;
            window.open(url, '_blank');		
            
        },        

        async startCase() {
            
            const qry = {
                "Project_Name": this.selectedCase.ProjectName,
                "UniComNm": this.selectedCase.UniComNm,
                "ComName": this.selectedCase.ComName
            }
            if( this.selectedCase.Memo && this.selectedCase.Memo.trim() !== '' ) {
                qry.Memo = this.selectedCase.Memo;
            }
            if (this.expectedVisitDate) {
                qry.Expect_Visit_Dt = this.formatToDateString(this.expectedVisitDate);
            }
            if (this.dueDate) {
                qry.Due_Dt = this.formatToDateString(this.dueDate);
            }

            
            console.log("起案參數",qry);
            try {
                const response = await this.$api.apicase.case_create(qry);
                // 啟案成功後, 需要刪除潛在客戶
                const respDelete = await this.$api.apipocx.pocx_delete( { IDs: [this.selectedCase.ID] } );
                notify({title: '成功',message: '起案成功',type: 'success'});
                // 將剛剛輸入的變數重置, 
                this.expectedVisitDate = '';
                this.dueDate = '';
                this.selectedCase = {};
                setTimeout(() => {
                    this.getList();
                }, 1000);
                console.log("起案回應",response,respDelete);   
            } catch (error) {
                console.error("起案失敗", error);
                notify({ title: '錯誤', message: '起案失敗，請稍後再試', type: 'error' });                
            }            
            this.startCaseDialogVisible = false;
        },

   

        btnOpStartCase(row) {
            this.startCaseDialogVisible = true;
            this.selectedCase = row;
            console.log("selectedCase",this.selectedCase);           
        },

        btnOpDelete(row) {
            const comname = '確定要刪除 ' + row.ComName + ' 嗎?';
            this.$confirm(comname, '提示', {
                confirmButtonText: '刪除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {

                // 呼叫API刪除客戶
                const qry = {
                    "IDs": [row.ID]                    
                }
                this.$api.apipocx.pocx_delete(qry).then(response => {
                    console.log("刪除客戶回應",response);
                    notify({ title: '成功', message: '刪除客戶成功', type: 'success' });
                    this.getList();
                }).catch(error => {
                    console.error("刪除客戶失敗", error);
                    notify({ title: '錯誤', message: '刪除客戶失敗，請稍後再試', type: 'error' });                
                    return;
                });
            }).catch(() => {
                notify({title: '信息', message: '已取消刪除', type: 'info' });                
            });
        },


        async startupBatchCase() {
            if(this.selectedItems.length==0) {
                notify({ title: '警告', message: '請先選擇要起案的客戶', type: 'warning' });
                return;
            }


            // 整批起案
            const successList = [];
            const failList = [];
            const total = this.selectedItems.length;

            for(let i=0;i<this.selectedItems.length;i++) {
                const row = this.selectedItems[i];
                const qry = {
                    "Project_Name": row.ProjectName,
                    "UniComNm": row.UniComNm,
                    "ComName": row.ComName,     
                    "memo": row.Memo
                }                
                
                try {
                    const response = await this.$api.apicase.case_create(qry);
                    console.log("起案回應",response);
                    // 啟案成功後, 需要刪除潛在客戶
                    const respDelete = await this.$api.apipocx.pocx_delete( { IDs: [row.ID] } );                    
                    successList.push(`${row.ComName}(${row.UniComNm})`);
                } catch(error) {
                    console.error("起案失敗", error);
                    failList.push(`${row.ComName}(${row.UniComNm})`);
                }
            }

            // 顯示結果通知
            if (failList.length === 0) {
                // 全部成功
                this.$notify({
                    title: '起案完成',
                    message: `成功起案 ${successList.length} 件`,
                    type: 'success',
                    duration: 3000
                });
            } else if (successList.length === 0) {
                // 全部失敗
                this.$notify({
                    title: '起案失敗',
                    message: `${failList.length} 件全部失敗`,
                    type: 'error',
                    duration: 5000
                });
            } else {
                // 部分成功
                this.$notify({
                    title: '起案完成',
                    message: `成功 ${successList.length} 件，失敗 ${failList.length} 件。失敗案件：${failList.join('、')}`,
                    type: 'warning',
                    duration: 8000
                });
            }

            console.log('成功案件:', successList);
            console.log('失敗案件:', failList);

            setTimeout(() => {
                this.getList();
            }, 1000);

            
            
        },

        // 儲存明細, 原因是新增新的客戶
        saveNewDetail() {
            // 檢核統一編號與公司名稱不可為空且必須數字8碼
            // 來核公司名稱是否空白
            if( !this.selectedCase.UniComNm || this.selectedCase.UniComNm.trim()=="" || !/^\d{8}$/.test(this.selectedCase.UniComNm) ) {
                notify({ type: 'warning', title: '警告', message: '統一編號不可為空且必須數字8碼' });
                return;
            }
            if( !this.selectedCase.ComName || this.selectedCase.ComName.trim()=="" ) {
                notify({ type: 'warning', title: '警告', message: '公司名稱不可為空' });
                return;
            }
            if( this.changeProjectID=="" ) {
                notify({ type: 'warning', title: '警告', message: '請選擇專案名稱' });
                return;
            }
            const qry = {
                "UniComNm": this.selectedCase.UniComNm,
                "ComName": this.selectedCase.ComName,
                "ProjectID": this.changeProjectID,
                "Memo": this.selectedCase.Memo
            }                
            
            this.$api.apipocx.pocx_create(qry).then(response => {
                console.log('新增潛在客戶成功:', response);
                if (response.statuscode==200)
                    notify({ type: 'success', title: '成功', message: `已成功新增潛在客戶: ${this.selectedCase.ComName}` });
                else
                    notify({ type: 'error', title: '失敗', message: `新增潛在客戶失敗: ${this.selectedCase.ComName}，原因：${response.message}` });
                this.dialogVisible = false;
                setTimeout(() => {
                    this.getList();
                }, 500);
            }).catch(error => {
                handleError(error, '新增潛在客戶失敗');
            });            

        },

        // 儲存明細, 原因是客戶自行修改
        saveDetail() {

            if( this.addOrEdit=='add' ) {
                this.saveNewDetail();
                return;
            }

            if( this.changeProjectID=="" ) {
                notify({ type: 'warning', title: '警告', message: '請選擇專案名稱' });
                return;
            }
            
            // TODO: 呼叫API儲存修改後的客戶資料
            const qry = {
                "ID": this.selectedCase.ID,
                "ProjectID": this.changeProjectID,
                "UniComNm": this.selectedCase.UniComNm,
                "ComName": this.selectedCase.ComName,
                "Memo": this.selectedCase.Memo
            }
            this.$api.apipocx.pocx_update(qry).then(response => {
                console.log("更新客戶資料回應",response);
                notify({title: '成功',message: '客戶資料更新成功',type: 'success'});
                this.dialogVisible = false;
                this.getList();
            }).catch(error => {
                console.error("更新客戶資料失敗", error);
                notify({ title: '錯誤', message: '客戶資料更新失敗，請稍後再試', type: 'error' });                
                return;
            });

            
        },

        btnOpDetail(row) {
            console.log("明細",row);
            this.popTitle = "編輯客戶名單資訊";
            this.selectedCase = row;
            this.selectedCase.Source = "自行開發";
            this.changeProjectID = this.selectedCase.ProjectID;
            this.addOrEdit = 'edit';
            this.dialogVisible = true;
        },

        closeDialog() {
            this.dialogVisible = false;
        },

        btnOpNews(row) {
            // 使用 window.open 在新視窗中打開頁面
            const route = this.$router.resolve({ name: 'bi-news-search', query: { q: row.ComName } });
            window.open(route.href, '_blank');
        },


        dashFormat: function(value) {
            
            if( value===null || value?.length!=8) 
                return "";
            else  {                
                return value.slice(0, 4) + '-' + value.slice(4, 6) + '-' + value.slice(6);
            }
        },

        async doSearch() {
            if( this.dateRange &&  this.dateRange.length==2 ) {
                this.listQuery.CreateDateStart = this.dashFormat(this.dateRange[0].toISOString().split('T')[0].replace(/-/g, ''));
                this.listQuery.CreateDateEnd = this.dashFormat(this.dateRange[1].toISOString().split('T')[0].replace(/-/g, ''));
            } else {
                delete this.listQuery.CreateDateStart
                delete this.listQuery.CreateDateEnd;                
            }

            if( this.keyword && this.keyword.trim()!="" ) {
                this.listQuery.SearchText = this.keyword.trim();
            } else {
                delete this.listQuery.SearchText;
            }
            if( this.keyword && this.keyword.trim() !== '' )
                this.$queryRecord(this, this.keyword, 'keyword');  // 記錄搜尋關鍵字            
            await this.getList();
        },

        async getList() {
            this.$store.dispatch("loadingHandler", true);

            let qry= {
                "Page_Size": this.listQuery.Page_Size,
                "Page_Num": this.listQuery.Page_Num
            }

            if( this.listQuery.source )
                qry.source = this.listQuery.source;
            if( this.listQuery.SearchText )
                qry.SearchText = this.keyword.trim();
            if( this.listQuery.ProjectName && this.listQuery.ProjectName.trim()!="全部" )
                qry.ProjectName = this.listQuery.ProjectName;

            if( this.dateRange &&  this.dateRange.length==2 ) {
                // dateRange[1] 是結束日期, 要在多加1天, 才能包含當天
                const endDate = new Date(this.dateRange[1]);
                endDate.setDate(endDate.getDate() + 1);
                qry.CreateDateStart = this.dashFormat(this.dateRange[0].toISOString().split('T')[0].replace(/-/g, ''));
                qry.CreateDateEnd = this.dashFormat(endDate.toISOString().split('T')[0].replace(/-/g, ''));
            }

            // 取得使用者所選區處ID
            const deptID = window.localStorage.getItem("deptID");  
            if (deptID) {
                qry.DeptID = deptID;
            }
            console.log("this.listQuery",qry);
            // 潛在客戶列表查詢

            await this.$api.apipocx.pocx_search(qry).then(response => {
                console.log("潛在客戶列表",response);
                this.tableData = response.data;
                this.totalLists = response.total;
                
                // 恢復跨頁選取狀態：若 selectedCaseMap 包含當前頁的 row，則標為已選
                this.isRestoringSelection = true;
                this.$nextTick(() => {
                    setTimeout(() => {
                        if (this.$refs.multipleTable && this.tableData && this.tableData.length) {
                            this.tableData.forEach(row => {
                                const key = String(row.ID);
                                if (this.selectedCaseMap && this.selectedCaseMap[key]) {
                                    try {
                                        this.selectedCaseMap[key] = row;
                                        this.$refs.multipleTable.toggleRowSelection(row, true);
                                    } catch (e) {
                                        // ignore
                                    }
                                }
                            });
                            this.selectedCases = Object.values(this.selectedCaseMap);
                        }
                        this.isRestoringSelection = false;
                    }, 10);
                });
            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "獲取潛在客戶列表失敗，請稍後再試",
                    type: "error"
                });                
            });
            this.$store.dispatch("loadingHandler", false);
        },

        // 上傳名單相關方法
        uploadNameList() {
            this.showupNameList = true;
            this.resetUploadForm(); // 確保表單是乾淨的
        },

        // 觸發文件選擇
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        
        // 處理選擇的文件
        handleFileChange(event) {
          const file = event.target.files[0];
          if (!file) return;
          
          // 檢查檔案類型
                    const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                        /\.xlsx$/i.test(file.name || '');
          
          if (!isExcel) {
                        notify({ title: '錯誤', message: '只能上傳 .xlsx 檔案!', type: 'error' });
            return;
          }
          
          if (file.size > 10 * 1024 * 1024) {
            notify({ title: '錯誤', message: '檔案大小不能超過 10MB!', type: 'error' });
            return;
          }
          this.uploadFileName = file.name;

          this.selectedFile = file;
          this.readExcelFile(file);
        },
        
        // 讀取 Excel 檔案內容
        readExcelFile(file) {
          const reader = new FileReader();
                    reader.onload = async (e) => {
            try {
                            const data = e.target.result;
                            const workbook = new ExcelJS.Workbook();
                            await workbook.xlsx.load(data);

                            const firstSheet = workbook.worksheets[0];
                            if (!firstSheet) {
                                notify({ title: '錯誤', message: 'Excel 檔案沒有工作表', type: 'error' });
                                return;
                            }

                            const rows = [];
                            firstSheet.eachRow({ includeEmpty: false }, row => {
                                rows.push(row.values.slice(1));
                            });

                            if (rows.length < 2) {
                                notify({ title: '錯誤', message: 'Excel 檔案內容為空，請確認資料格式', type: 'error' });
                                return;
                            }

                            const headers = rows[0].map(h => (h == null ? '' : String(h).trim()));
                            const jsonData = rows.slice(1).map(row => {
                                const item = {};
                                headers.forEach((header, idx) => {
                                    if (!header) return;
                                    item[header] = row[idx] == null ? '' : row[idx];
                                });
                                return item;
                            });
              
              // 檢查數據是否為空
              if (jsonData.length === 0) {
                notify({ title: '錯誤', message: 'Excel 檔案內容為空，請確認資料格式', type: 'error' });
                return;
              }
              
                            // 將限辦期限從 JS Date 物件或 Excel serial number 轉為 YYYY-MM-DD 字串
                            const dateFields = ['限辦期限'];
                            const processedData = jsonData.map(item => {
                                dateFields.forEach(field => {
                                    if (item[field] instanceof Date) {
                                        const d = item[field];
                                        item[field] = `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
                                    } else if (typeof item[field] === 'number' && item[field] > 0) {
                                        const d = new Date((item[field] - 25569) * 86400 * 1000);
                                        item[field] = `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
                                    }
                                });
                                return item;
                            });
                            this.parsedData = processedData;
              console.log('解析後的資料:', this.parsedData);
              
              notify({
                title: '成功',
                message: `已成功讀取 ${jsonData.length} 筆資料`,
                type: 'success'
              });
            } catch (error) {
              console.error('解析 Excel 檔案時發生錯誤:', error);
              notify({ title: '錯誤', message: '解析檔案失敗，請確認檔案格式是否正確', type: 'error' });
            }
          };
          
          reader.onerror = () => {
            notify({ title: '錯誤', message: '讀取檔案時發生錯誤', type: 'error' });
          };
          
          reader.readAsArrayBuffer(file);
        },

        async verifiedFunction(data) {
            // 需要檢核數據完整性與正確性  
            // 必填欄位: 區處、分行代號、統一編號
            // 其他欄位若空白，也允許上傳
            // 限辦期限: 檢核是否有效日期格式 (若有輸入)
            // 數字字段: 資本額、員工人數、近一年貢獻度、外匯存款AUM、AUM (允許逗號、小數點) (若有輸入)
            // Y/N字段: 台幣放款戶(Y/N)、有外幣存款(Y/N)、衍生性金融商品(Y/N) (若有輸入)
            
            const qry = {
                "Page_Num": 1,
                "Page_Size": 1000,
                "isSys": true              
            }           
            
            let errorList = [];
            // 數字字段驗證的正則（允許逗號和小數點）：符合 1,000.5, 1000, 1,000,235.00 等格式
            const numberRegex = /^[\d,]+(\.\d+)?$/;
            // Y/N 字段驗證
            const ynRegex = /^[YyNn]$/;
            
            return await this.$api.apidivison.division_info_list(qry).then(response => {
                const division_info_list = response.data;                
                console.log("區處分行列表",division_info_list);
                data.forEach((item, index) => {
                    // 將可能被 Excel 解析為數字的欄位統一轉為字串，避免 .trim() 報錯
                    ['區處名稱(*)', '分行代號(*)', '統一編號(*)', '客戶名稱', '專案名稱(*)', '信評等級', '台幣放款戶(Y/N)', '有外幣存款(Y/N)', '衍生性金融商品(Y/N)'].forEach(f => {
                        if (item[f] !== undefined && item[f] !== null) item[f] = String(item[f]);
                    });

                    // 必填欄位檢核
                    if (!item["區處名稱(*)"] || item["區處名稱(*)"].trim() === '') {
                        errorList.push(`第 ${index + 1} 列：區處名稱 為必填欄位`);
                    }
                    if (!item["分行代號(*)"] || item["分行代號(*)"].trim() === '') {
                        errorList.push(`第 ${index + 1} 列：分行代號 為必填欄位`);
                    }
                    if (!item["統一編號(*)"] || item["統一編號(*)"].trim() === '') {
                        errorList.push(`第 ${index + 1} 列：統一編號 為必填欄位`);
                    }
                    // 專案名稱檢核（必填欄位）
                    if (!item["專案名稱(*)"] || item["專案名稱(*)"].trim() === '') {                        
                        errorList.push(`第 ${index + 1} 列：專案名稱為必填欄位`);
                    }
                    
                    // 區處、分行代號 檢核（若有輸入才檢核）
                    if (item["區處名稱(*)"] && item["分行代號(*)"]) {
                        const division_match = division_info_list.find(div => div.DivisionName === item["區處名稱(*)"] && div.DeptID === item["分行代號(*)"]);
                        if (!division_match) {
                            errorList.push(`第 ${index + 1} 列：區處名稱或分行代號錯誤: 區處名稱=${item["區處名稱(*)"]}, 分行代號=${item["分行代號(*)"]}`);
                        }
                    }
                    
                    // 統一編號檢核（若有輸入才檢核，先 trim 避免空白字元干擾）
                    if (item["統一編號(*)"] && !/^\d{8}$/.test(item["統一編號(*)"].trim())) {
                        errorList.push(`第 ${index + 1} 列：統一編號格式錯誤: ${item["統一編號(*)"]}`);
                    }
                    
                    // 限辦期限檢核（必填，且需為實際存在的有效日期）
                    if (!item["限辦期限"] || String(item["限辦期限"]).trim() === '') {
                        errorList.push(`第 ${index + 1} 列：限辦期限 為必填欄位`);
                    } else {
                        const dueDateStr = String(item["限辦期限"]).trim();
                        const match = dueDateStr.match(/^(\d{4})[-\/]?(\d{1,2})[-\/]?(\d{1,2})$/);

                        if (!match) {
                            errorList.push(`第 ${index + 1} 列：限辦期限格式錯誤（需為 YYYY-MM-DD）: ${item["限辦期限"]}`);
                        } else {
                            const year = Number(match[1]);
                            const month = Number(match[2]);
                            const day = Number(match[3]);
                            const d = new Date(year, month - 1, day);

                            const isValidDate =
                                d.getFullYear() === year &&
                                d.getMonth() === month - 1 &&
                                d.getDate() === day;

                            if (!isValidDate) {
                                errorList.push(`第 ${index + 1} 列：限辦期限日期無效: ${item["限辦期限"]}`);
                            }
                        }
                    }
                    
                    // 數字字段驗證（允許逗號和小數點）（若有輸入才檢核）
                    const numberFields = ['資本額', '員工人數', '近一年貢獻度(千元)', '外匯存款AUM(千元)', 'AUM'];
                    numberFields.forEach(field => {
                        if (item[field] && item[field] !== '') {
                            // 轉換為字串並去除尾部非數字字元（如「人」、「元」等中文單位）及前後空白
                            const fieldValue = String(item[field]).trim().replace(/[^\d,.]+$/, '');
                            const cleanValue = fieldValue.replace(/,/g, '');
                            if (!numberRegex.test(fieldValue)) {
                                errorList.push(`第 ${index + 1} 列：${field} 必須是數字格式（允許逗號和小數點）: ${item[field]}`);
                            }
                            // 使用轉換後的字串變數
                            if (fieldValue.includes('.')) {
                                const decimalPart = fieldValue.split('.')[1];
                                if (decimalPart && decimalPart.length > 2) {
                                    errorList.push(`第 ${index + 1} 列：${field} 小數位最多 2 位: ${item[field]}`);
                                }
                            }
                        }
                    });
                    
                    // Y/N 字段驗證（若有輸入才檢核）
                    const ynFields = ['台幣放款戶(Y/N)', '有外幣存款(Y/N)', '衍生性金融商品(Y/N)'];
                    ynFields.forEach(field => {
                        if (item[field] && item[field] !== '') {
                            if (!ynRegex.test(item[field])) {
                                errorList.push(`第 ${index + 1} 列：${field} 必須填寫 Y 或 N: ${item[field]}`);
                            }
                        }
                    });
                });
                
                console.error("資料檢核錯誤", errorList);
                // 如果有錯誤，顯示錯誤訊息
                if (errorList.length > 0) {
                    this.validationErrors = errorList.map(err => ({ error: err }));
                    this.errorDialogVisible = true;
                    throw new Error('資料檢核失敗');
                }                
                return errorList; 
            }).catch(error => {
                // 驗證錯誤已由 errorDialogVisible 錯誤對話框告知使用者，不重複顯示 notify
                if (error.message !== '資料檢核失敗') {
                    notify({
                        title: "錯誤",
                        message: error.message || "獲取區處分行列表失敗，請稍後再試",
                        type: "error"
                    });
                }
                throw error;
            });
            
        },
        
        // 提交數據到後端 API
        async submitData() {
          if (this.parsedData.length === 0) {
            notify({ title: '警告', message: '沒有可提交的數據', type: 'warning' });            
            return;
          }

   
          
          this.submitting = true;
          let uploadCount = 0;
          
          try {
            console.log("開始檢核上傳資料", this.parsedData);

            // 預防標題中的空白字元影響欄位名稱比對
            this.parsedData = this.parsedData.map(item => {
                const newItem = {};
                Object.keys(item).forEach(key => {
                    const trimmedKey = key.trim(); // 去除欄位名稱的前後空白
                    newItem[trimmedKey] = item[key];
                });
                return newItem;
            });

            // 需要檢核數據完整性與正確性  --------------------------------------
            // 需要檢核的欄位: 
            // 區處、分行代號 : 需要讀取API取得目前的區處分行資訊
            // 統一編號: 檢核是否8碼
            // 限辦期限: 檢核是否有效日期格式                   
            await this.verifiedFunction(this.parsedData);

            console.log("檢核完成，開始送出資料", this.parsedData);
    
            // 轉換成 API 所需格式並送出
            let casesList = [];
            this.parsedData.forEach(item=>{
               let qry = { 
                    "DivisionName": item["區處名稱(*)"],
                    "DeptID": item["分行代號(*)"],
                    "UniComNm": item["統一編號(*)"],
                    "ComName": item["客戶名稱"],
                    "ProjectName": item["專案名稱(*)"],
                    "DueDt": item["限辦期限"],
                    "CreditRating": item["信評等級"],
                    "CapitalAmount": item["資本額"],
                    "EmployeeCount": item["員工人數"],
                    "TwdLoanAccountYN": item["台幣放款戶(Y/N)"],
                    "FxDepositAccountYN": item["有外幣存款(Y/N)"],
                    "DerivativeProductYN": item["衍生性金融商品(Y/N)"],
                    "LastYearContribution": item["近一年貢獻度(千元)"],
                    "FxDepositAUM": item["外匯存款AUM(千元)"],
                    "TotalAUM": item["AUM"],                
                    "Memo1": item["備註1"],
                    "Memo2": item["備註2"],
                    "Memo3": item["備註3"]
                }
                casesList.push(qry);
            });
            uploadCount = casesList.length;            

            const qry = {
                "Cases": casesList
            }
            console.log("送出名單資料",qry);
            this.$store.dispatch("loadingHandler", true);
            this.$api.apicase.create_head_office(qry).then(async response => {
                console.log("送出名單回應",response);
                if (response.statuscode === 200) {
                    // 後端會在派案時, 新增總行標籤, 因此這裡不需要再額外呼叫 API 設定總行標籤, 避免重複設定造成效能問題
                    // 上傳成功後，逐筆設定總行標籤（tag 使用專案名稱）
                    // const tagTasks = [];
                    // this.parsedData.forEach(item => {
                    //     const UniComNm = String(item["統一編號"] || '').trim();
                    //     const tag = String(item["專案名稱"] || '').trim();
                    //     if (!UniComNm || !tag) return;

                    //     const params = {
                    //         "UniComNm": UniComNm,
                    //         "TagValues": [tag]
                    //     };

                    //     tagTasks.push(
                    //         this.$api.apitags.add_hq_category_tag(params).catch(error => {
                    //             handleError(error, '新增總行標籤失敗');
                    //         })
                    //     );
                    // });

                    // await Promise.all(tagTasks);

                    notify({ title: '成功', message: '名單上傳成功', type: 'success' });
                    this.showupNameList = false;
                    this.resetUploadForm();
                    this.getList(); // 重新載入列表
                } else {
                    notify({ title: '錯誤', message: response.message || '上傳失敗', type: 'error' });
                }
            }).catch(error => {
                console.error("送出名單錯誤",error);
                notify({ title: '錯誤', message: '上傳失敗，請稍後再試', type: 'error' });
            }).finally(() => {
                this.$store.dispatch("loadingHandler", false);
            });

          } catch (error) {
                        // 若驗證錯誤對話框已顯示，不重複提示（錯誤對話框已清楚列出所有問題）
                        if (!this.errorDialogVisible) {
                                console.error('提交數據時發生錯誤:', error);
                                notify({
                                    title: '錯誤',
                                    message: `提交失敗，請稍後再試。錯誤訊息: ${error.message || '未知錯誤'}`,
                                    type: 'error'
                                });
                        }
          } finally {

            // 要做一個稽核記錄.. 呼叫後端 API 紀錄匯出行為                
            const setAudit = {
                "menu_path": ["客戶名單管理", "潛在客戶名單管理"],
                "action_type": "upload",
                "action_name": "上傳名單",
                "details": {
                    "file_name": this.uploadFileName,
                    "upload_count": uploadCount
                }
            }
            const resp = await this.$api.apimgrs.setAuditLog(setAudit);

            this.submitting = false;
            this.$store.dispatch("loadingHandler", false);
          }
        },
        
        // 取消上傳
        cancelUpload() {
          this.resetUploadForm();
        },
        
        // 重置表單
        resetUploadForm() {
          this.selectedFile = null;
          this.parsedData = [];
          this.addInfo.memo = '';
          if (this.$refs.fileInput) {
            this.$refs.fileInput.value = '';
          }
        },

        async exportCase() {
            // 檢查是否有勾選資料
            const rows = this.getSelectedCases() || [];
            if (!rows || rows.length === 0) {
                notify({ title: '警告', message: '請先勾選要匯出的潛在客戶', type: 'warning' });
                return;
            }

            try {
                // 定義欄位順序和中文標題
                const fieldMapping = [
                    { key: 'UniComNm', label: '統一編號' },
                    { key: 'ComName', label: '公司名稱' },
                    { key: 'ProjectName', label: '專案名稱' },
                    { key: 'DivisionName', label: '區處' },
                    { key: 'DeptName', label: '分行名稱' },
                    { key: 'UserName', label: '承辦人' },
                    { key: 'CreateDt', label: '建立時間' },
                    { key: 'Memo', label: '備註' }
                ];

                // 轉換資料：只保留指定欄位，並使用中文標題
                const exportData = rows.map(item => {
                    const newItem = {};
                    fieldMapping.forEach(field => {
                        newItem[field.label] = item[field.key] || '';
                    });
                    return newItem;
                });
                console.log("匯出資料", exportData);
                const exportUniComNms = exportData.slice(0, 10).map(d => d['統一編號']).join(', ');

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('潛在客戶列表');

                const headers = fieldMapping.map(field => field.label);
                worksheet.addRow(headers);
                exportData.forEach(item => {
                    worksheet.addRow(headers.map(header => item[header]));
                });
                
                const now = new Date();
                const ts = `${now.getFullYear()}${String(now.getMonth()+1).padStart(2,'0')}${String(now.getDate()).padStart(2,'0')}_${String(now.getHours()).padStart(2,'0')}${String(now.getMinutes()).padStart(2,'0')}`;
                const fileName = `潛在客戶列表_${ts}.xlsx`;
                
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                // 要做一個稽核記錄.. 呼叫後端 API 紀錄匯出行為                
                const setAudit = {
                    "menu_path": ["客戶名單管理", "潛在客戶名單管理"],
                    "action_type": "export",
                    "action_name": "匯出",
                    "details": {
                        "UniComNms": exportUniComNms,                        
                        "exported_count": exportData.length
                    }
                }
                const resp = await this.$api.apimgrs.setAuditLog(setAudit);                
                
                notify({
                    title: "成功",
                    message: `已下載 ${fileName}，共 ${rows.length} 筆資料`,
                    type: "success"
                });
            } catch (error) {
                console.error("匯出失敗", error);
                notify({
                    title: "錯誤",
                    message: "匯出失敗，請稍後再試",
                    type: "error"
                });
            }
        },

        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },

        handleSelectionChange(selectedRows) {
            // 若正在恢復選取狀態，跳過此次處理
            if (this.isRestoringSelection) {
                return;
            }
            
            // 當前頁面被選取的 row 陣列
            selectedRows = selectedRows || [];

            // 將當前頁被選的加入 map（使用字串 key 確保一致）
            selectedRows.forEach(r => {
                if (r && r.ID !== undefined && r.ID !== null) {
                    this.selectedCaseMap[String(r.ID)] = r;
                }
            });

            // 對當前頁未被選的 row，從 map 中移除（只影響當前頁）
            if (this.tableData && this.tableData.length) {
                this.tableData.forEach(row => {
                    const key = String(row.ID);
                    const stillSelected = selectedRows.some(r => String(r.ID) === key);
                    if (!stillSelected && this.selectedCaseMap[key]) {
                        delete this.selectedCaseMap[key];
                    }
                });
            }

            // 同步方便用的陣列表示
            this.selectedCases = Object.values(this.selectedCaseMap);
            this.selectedItems = selectedRows;  // 保持向後相容
            console.log('目前跨頁被選取的項目數:', this.selectedCases.length);
        },

        getSelectedCases() {
            const mapVals = Object.values(this.selectedCaseMap || {});
            if (mapVals && mapVals.length) return mapVals;
            if (this.selectedCases && this.selectedCases.length) return this.selectedCases;
            return (this.$refs.multipleTable && this.$refs.multipleTable.selection) || [];
        },  

        getFunctions() {

            const funs = this.$store.getters.userInfo;
            const roleName = this.$store.getters.userRole;
            const DeptID = this.$store.getters.deptID;
            console.log("使用者角色:",roleName);
            // 只有HD, HC的角色, 可以上傳標籤, 熱門標籤
            if (roleName === 'UAO' || roleName === 'UC' )
                this.btnStartCaseVisible = true;            
            else
                this.btnStartCaseVisible = false;

            // 只有HD, HC, HE	HC1 的角色, 可以上傳名單
            if (roleName === 'HD' || roleName === 'HC' || roleName ==='HE' || roleName==='HC1' ) {
                if( DeptID=='041' ) // 國際部不能有上傳名單權限
                    this.btnUploadNameVisible = false;
                else
                    this.btnUploadNameVisible = true;
            }
            else
                this.btnUploadNameVisible = false;


        },
        
        // 打開新增標籤對話框
        openAddTagDialog() {
            // 重置表單
            this.newTagForm.content = '';
            // 取得表格中勾選的公司
            const selectedCases = this.getSelectedCases();
            if (!selectedCases || selectedCases.length === 0) {
                notify({ title: '請注意', type: 'warning', message: '請先在表格中勾選要新增標籤的公司' });
                return;
            }
            // 將選中的公司 UniComNm 存入陣列
            this.selectedComUniComNmList = selectedCases.map(item => item.UniComNm);
            this.selectedComUniComNm = '';
            // 顯示對話框
            this.showAddTagDialog = true;
        },
        
        // 根據 UniComNm 取得公司名稱
        getCompanyName(uniComNm) {
            const company = this.tableData.find(item => item.UniComNm === uniComNm);
            return company ? company.ComName : uniComNm;
        },
        
        // 保存新標籤
        async saveNewTagFromDrawer() {
            if (!this.newTagForm.content.trim()) {
                notify({ title: '請注意', type: 'warning', message: '請輸入標籤內容' });
                return;
            }
            
            if (!this.selectedComUniComNmList || this.selectedComUniComNmList.length === 0) {
                notify({ title: '請注意', type: 'warning', message: '未選擇公司' });
                return;
            }
            
            // 若newTagForm.content中有多個標籤，以,分隔，組成陣列
            const tagArray = this.newTagForm.content.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
            
            // 對所有選中的公司新增標籤
            const successCount = [];
            const failList = [];
            
            try {
                for (const uniComNm of this.selectedComUniComNmList) {
                    const selectedCompany = this.tableData.find(item => item.UniComNm === uniComNm);
                    if (!selectedCompany) {
                        failList.push(uniComNm);
                        continue;
                    }
                    
                    const params = {
                        "UniComNm": uniComNm,
                        "TagValues": tagArray
                    };
                    console.log('新增標籤參數:', params);
                    
                    try {
                        // 呼叫 API 新增自訂標籤
                        const response = await this.$api.apitags.add_category_tag(params);
                        console.log('新增標籤成功:', response);
                        successCount.push(selectedCompany.ComName);
                    } catch (error) {
                        console.error(`為公司 ${selectedCompany.ComName} 新增標籤失敗:`, error);
                        failList.push(selectedCompany.ComName);
                    }
                }
                
                // 顯示結果通知
                if (failList.length === 0) {
                    notify({ 
                        type: 'success', 
                        title: '成功', 
                        message: `已成功為 ${successCount.length} 家公司新增標籤` 
                    });
                } else if (successCount.length === 0) {
                    notify({ 
                        type: 'error', 
                        title: '失敗', 
                        message: `所有公司新增標籤失敗，共 ${failList.length} 家` 
                    });
                } else {
                    notify({ 
                        type: 'warning', 
                        title: '部分成功', 
                        message: `成功 ${successCount.length} 家，失敗 ${failList.length} 家` 
                    });
                }

                // 也要把表格中對應的公司取消選取
                if (this.$refs.multipleTable && this.tableData && this.tableData.length) {
                    this.tableData.forEach(row => {
                        if (this.selectedComUniComNmList.includes(row.UniComNm)) {
                            try {
                                this.$refs.multipleTable.toggleRowSelection(row, false);
                            } catch (e) {
                                // ignore
                            }
                        }
                    });
                }
                // 清空選取的公司列表
                this.selectedComUniComNmList = [];                

                // 關閉對話框
                this.showAddTagDialog = false;
                setTimeout(() => {
                    this.getList(); // 重新載入列表以顯示更新後的標籤
                }, 500);
                

                
                // 重置表單
                this.newTagForm.content = '';
                this.selectedComUniComNmList = [];
                this.selectedComUniComNm = '';
            } catch (error) {
                handleError(error, '新增標籤失敗');
            }
        },



    },    

    async mounted() {
        this.$store.dispatch("loadingHandler", true);
        await this.loadProjectNameList();
        let today = new Date();
        let threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
        this.dateRange = [threeMonthsAgo, today];
        await this.getFunctions();
        await this.getList();
        // 載入專案名稱選項
        
        this.$store.dispatch("loadingHandler", false);
    }   
}
</script>

<style lang="scss" scoped>
#cxMgmtBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;

    .searchWrap   {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;

            .itemWrap {
                span {
                    margin-right: 10px;
                }
                display: flex;
                flex-direction: row;
                align-items: center;   
                width: 30%;             
                margin-top:10px; 
                margin-bottom: 10px;
            }
        }    
    .row2 {
        display: flex;
        flex-direction: row;    
        justify-content: space-between;
        margin-bottom: 10px;
        span {
            margin-right: 15px;
        }        
        .el-button {
            margin-right: 10px;
        }
    }
    
  }
    .content {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    margin-top: 20px;
    padding: 0px 5%;
    .legend {
        display: flex;
        flex-direction: row;
        .legendItem {
            width: 80px;
            margin: 5px 10px;
        }
        
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   } 
}

  .dialogBox {
    display: flex;
    flex-direction: column;;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row1 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: center;
            }
        }
    }
    .row2 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: right;
            }
        }
    }    
  }

    .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }

.cxInfoitem {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 5px;
    label {        
        width: 150px;
        font-weight: bold;
    }
    .el-select, .el-input {
        flex: 1;
    }
}

</style>